export default __webpack_public_path__ + "static/sdk-header@3x-b9baf0753337dd763955ead83fd1dd70.gif";